import { Component, Input } from "@angular/core";
import { SafeResourceUrl } from "@angular/platform-browser";

@Component({
    selector: "app-preview-document",
    templateUrl: "./preview.component.html",
    styleUrls: ["./preview.component.scss"],
})
export class PreviewDocumentComponent {
    @Input() url: SafeResourceUrl;
    @Input() isPDF: boolean;
    @Input() isModal: boolean;
}
